import React, { useContext } from "react";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../starek.css";
import StarekContext from "../../context/StarekContext";
import {
    SidebarView,
    SidebarContextProvider,
    useSyncedField,
} from "../../components/Sidebar";

function PartBasicDetails() {
    const [name, setName] = useSyncedField("name", "");
    const [description, setDescription] = useSyncedField("description", "");

    return (
        <>
            <Form.Group className="mb-3" controlId="part_name">
                <Form.Label>
                    Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Enter here"
                    name="part_name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="part_description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Max allowed characters: 120"
                    name="part_description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </Form.Group>
        </>
    );
}

function PartSidebar({ show, item, plantId, onDiscard, onSave, onDelete }) {
    const starekContext = useContext(StarekContext);

    const handleSaveInternal = async (emittedData, entity) => {
        try {
            // Validation
            if (!emittedData.name?.trim()) {
                starekContext.showError("Part name is required");
                throw new Error("Part name is required");
            }

            const payload = {
                id: entity?.id,
                name: emittedData.name.trim(),
                description: emittedData.description || "",
                plant_id: plantId,
            };

            await onSave(payload);

            starekContext.showSuccess(
                entity?.id
                    ? `Part "${payload.name}" updated successfully`
                    : `Part "${payload.name}" created successfully`,
            );
        } catch (error) {
            console.error("Error saving part:", error);
            starekContext.showError(
                error?.message || "Failed to save part. Please try again.",
            );
            throw error;
        }
    };

    const handleDeleteInternal = async (entity) => {
        await onDelete(entity);
    };

    const handleDiscardInternal = async () => {
        await onDiscard();
    };

    return (
        <SidebarContextProvider
            entity={item}
            show={show}
            onSave={handleSaveInternal}
            onDelete={item?.id ? handleDeleteInternal : null}
            onDiscard={handleDiscardInternal}
        >
            <SidebarView entityName="Part">
                <SidebarView.Page
                    key={item?.id || "new"}
                    name="basic_details"
                    title="Basic Details"
                >
                    <PartBasicDetails />
                </SidebarView.Page>
            </SidebarView>
        </SidebarContextProvider>
    );
}

export default PartSidebar;
